import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { NgPipesModule } from 'ngx-pipes';

import { authReducer, AuthEffects } from '@app/core/auth';
import { PartialsModule } from '@app/layout-sidebar/partials/partials.module';

import { AuthRoutingModule } from './auth-routing.module';
import {
  AuthSignInComponent,
  AuthBaseComponent,
  AuthForgotComponent,
  AuthRecoverComponent,
  AuthChangePasswordComponent,
  AuthFormModalComponent,
  AuthErrorComponent,
} from './components';

//

const angularModules = [
  CommonModule,
  HttpClientModule,
  FormsModule,
  ReactiveFormsModule,
];

const components = [
  AuthSignInComponent,
  AuthBaseComponent,
  AuthForgotComponent,
  AuthRecoverComponent,
  AuthChangePasswordComponent,
  AuthFormModalComponent,
  AuthErrorComponent,
];

const libModules = [PartialsModule, NgPipesModule, TranslateModule.forChild()];

const materialModules = [
  MatInputModule,
  MatSelectModule,
  MatOptionModule,
  MatTooltipModule,
  MatDatepickerModule,
  MatRadioModule,
  MatDialogModule,
  MatButtonModule,
  MatIconModule,
  MatCheckboxModule,
  MatProgressSpinnerModule,
];

const routingModule = [AuthRoutingModule, RouterModule];

@NgModule({
  declarations: [...components],
  imports: [
    ...angularModules,
    ...libModules,
    ...materialModules,
    ...routingModule,
    StoreModule.forFeature('auth', authReducer),
    EffectsModule.forFeature([AuthEffects]),
  ],
  providers: [],
})
export class AuthModule {}
